import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Filter } from 'lucide-react';
import { apiRequests } from '../../shared/api/apiRequests';
import { dateToString } from '../../shared/utils/parseDate.js';
import { ORDER_FILTERS, ORDER_STATUS_MAP } from './constants';
import { Pagination } from '../../features/Pagination/index.js';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';
import './Orders.css';

const FILTER_TABS = [
  { key: null, label: 'Все' },
  { key: 'unpaid', label: 'Не оплачены' },
  { key: 'paid_for', label: 'Оплачены' },
  { key: 'in_delivery', label: 'В доставке' },
  { key: 'delivered', label: 'Доставлены' },
];

const OrdersPage = () => {
  const [data, setData] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();

  const activeFilter = searchParams.get('type');
  const typeOfOrder = ORDER_FILTERS[activeFilter];

  const loadOrders = (count = 10, offset = 0, query = '') => {
    if (typeOfOrder) {
      apiRequests.products
        .getOrdersFiltered(typeOfOrder, query || undefined, undefined, count, offset)
        .then((res) => setData(res));
      return;
    }

    apiRequests.products.getOrders(count, offset).then((res) => setData(res));
  };

  useEffect(() => {
    loadOrders();
  }, [activeFilter]);

  const handleSearch = () => {
    loadOrders(10, 0, searchValue);
  };

  const handleFilterChange = (filterKey) => {
    if (!filterKey) {
      setSearchParams({});
      return;
    }

    setSearchParams({ type: filterKey });
  };

  return (
    <div className="orders-page">
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск заказов..."
      />

      <section className="orders-filters-shell">
        <div className="orders-filters-label">
          <Filter size={14} />
          <span>Фильтры</span>
        </div>

        <div className="orders-filters-tabs">
          {FILTER_TABS.map((tab) => {
            const isActive = (tab.key === null && !activeFilter) || tab.key === activeFilter;

            return (
              <button
                key={tab.label}
                type="button"
                className={`orders-filter-btn ${isActive ? 'active' : ''}`}
                onClick={() => handleFilterChange(tab.key)}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </section>

      <div className="orders-results">
        {!data.items || data.items.length === 0 ? (
          <p className="orders-empty">По вашему запросу ничего не найдено</p>
        ) : (
          data.items?.map((item) => {
            const status = ORDER_STATUS_MAP[item.status] || { text: 'Новый', variant: 'warning' };

            return (
              <EntityCard
                key={item.id}
                className="orders-card"
                title={`#${item.id}`}
                subtitle={item.user ? `${item.user.name} ${item.user.surname}` : 'Неизвестный пользователь'}
                badge={{ text: status.text, variant: status.variant }}
                fields={[
                  { label: 'Сумма', value: `${item.totalSum || 0} ${item.currency?.symbol || 'USD'}` },
                  { label: 'Создано', value: dateToString(item.createdAt) },
                ]}
                editLink={`/shop/orders/${item.id}`}
              />
            );
          })
        )}
      </div>

      <Pagination
        noRequest
        count={data.totalCount}
        itemsPerPage={10}
        onChange={(page) => loadOrders(10, 10 * page, searchValue)}
      />
    </div>
  );
};

export default OrdersPage;
